import { useEffect } from 'react';

const CLOSE_KEY = 'Escape';

interface UseProductDetailsShortcutsParams {
  isEnabled: boolean;
  onClose: () => void;
}

const useProductDetailsShortcuts = ({ isEnabled, onClose }: UseProductDetailsShortcutsParams) => {
  useEffect(() => {
    if (!isEnabled) {
      return undefined;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === CLOSE_KEY) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isEnabled, onClose]);
};

export default useProductDetailsShortcuts;
